import React from 'react'
import { useLocation } from 'react-router-dom'
import { AdminFilterProvider } from './AdminFilterProvider'
import {
	AdminBrand,
	AdminContainer,
	AdminContent,
	AdminNav,
	AdminNavLink,
	BackToAppLink,
} from './AdminLayout.styles'
import DateRangeFilter from './DateRangeFilter'
import InternalDataToggle from './InternalDataToggle'

/**
 * Dedicated shell for the internal admin surface, deliberately separate from the
 * consumer trip layout/nav. Hosts the global creation-date filter that scopes
 * every admin view via {@link AdminFilterProvider}.
 */
const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const { pathname } = useLocation()
	const isOverview = pathname === '/admin' || pathname.startsWith('/admin/overview')
	const isUsers = pathname.startsWith('/admin/users')
	const isTrips = pathname.startsWith('/admin/trips')
	const isEvents = pathname.startsWith('/admin/events')
	const isIdeas = pathname.startsWith('/admin/ideas')
	const isExpenses = pathname.startsWith('/admin/expenses')

	return (
		<AdminFilterProvider>
			<AdminContainer>
				<AdminNav>
					<AdminBrand>Orbit Admin</AdminBrand>
					<AdminNavLink to="/admin/overview" $active={isOverview}>
						Overview
					</AdminNavLink>
					<AdminNavLink to="/admin/users" $active={isUsers}>
						Users
					</AdminNavLink>
					<AdminNavLink to="/admin/trips" $active={isTrips}>
						Trips
					</AdminNavLink>
					<AdminNavLink to="/admin/events" $active={isEvents}>
						Events
					</AdminNavLink>
					<AdminNavLink to="/admin/ideas" $active={isIdeas}>
						Ideas
					</AdminNavLink>
					<AdminNavLink to="/admin/expenses" $active={isExpenses}>
						Expenses
					</AdminNavLink>
					<DateRangeFilter />
					<InternalDataToggle />
					<BackToAppLink to="/home">← Back to app</BackToAppLink>
				</AdminNav>
				<AdminContent>{children}</AdminContent>
			</AdminContainer>
		</AdminFilterProvider>
	)
}

export default AdminLayout
